module.exports = __webpack_public_path__ + "static/tag-90b31ff57c492ef29b710b2096919de8.gif";